import { render, staticRenderFns } from "./ProcessingUserEmployees.vue?vue&type=template&id=b4d3d3c2&scoped=true"
import script from "./ProcessingUserEmployees.vue?vue&type=script&lang=js"
export * from "./ProcessingUserEmployees.vue?vue&type=script&lang=js"
import style0 from "./ProcessingUserEmployees.vue?vue&type=style&index=0&id=b4d3d3c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d3d3c2",
  null
  
)

export default component.exports